<template>
    <v-alert
        border="left"
        colored-border
        :color="color"
        :icon="icon"
        :elevation="elevation"
        class="warning-alert notice-alert text-body-2 mb-4"
        :style="noticeStyle"
        :type="type"
    >
        <div class="warning__layout ml-2">
            <div class="warning__text">
                <slot />
            </div>
            <div v-if="$slots.button" class="warning__actions"><slot name="button" /></div>
        </div>
    </v-alert>
</template>

<script>
export default {
    props: {
        elevation: {
            type: Number,
            default: 0,
        },
        icon: {
            type: String,
            required: false,
        },
        type: {
            type: String,
            default: "warning",
            required: false,
        },
    },
    computed: {
        color() {
            switch (this.type) {
                case "info":
                    return "primary";
                default:
                    return this.type;
            }
        },
        noticeStyle() {
            return { "--notice-color": this.$vuetify.theme.currentTheme[this.color] || this.color };
        },
    },
};
</script>

<style scoped lang="scss">
.warning-alert {
    container-type: inline-size;
    container-name: warning;

    ::v-deep .v-alert__wrapper {
        overflow: visible;
    }
}

.warning__layout {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.warning__text {
    min-width: 0;
    overflow-wrap: break-word;
}

.warning__actions {
    min-width: 0;
    max-width: 100%;

    ::v-deep .v-btn:not(.v-btn--icon) {
        max-width: 100%;
        width: auto;
        height: auto;
        min-height: 36px;
        padding-top: 8px;
        padding-bottom: 8px;
    }

    ::v-deep .v-btn__content {
        flex: 1 1 auto;
        min-width: 0;
        white-space: normal;
    }
}

@container warning (min-width: 720px) {
    .warning__layout {
        flex-direction: row;
        align-items: center;
        gap: 20px;
    }

    .warning__text {
        flex: 1 1 auto;
    }

    .warning__actions {
        flex: 0 1 auto;
    }
}
</style>
